export function buildApplicationBuildPayload({
  sourceProjectVersionId,
  categoryId,
  name,
  description,
  activations
} = {}) {
  return {
    source_project_version_id: sourceProjectVersionId,
    ...(categoryId ? { category_id: categoryId } : {}),
    name,
    description,
    ...(activations?.length ? { activations } : {})
  };
}
